module.exports = __webpack_public_path__ + "static/media/qatar-air.f733d3a2.svg";